import { Conversation } from '../api/models';
import { Action, AppState } from './AppProvider';
import { getCacheSelectedRAGIds, setCacheSelectedRAGIds } from './LocalStorageCache';

// Define the reducer function
export const appStateReducer = (state: AppState, action: Action): AppState => {
    console.log(action.type)
    switch (action.type) {
        case 'SET_SIDEBAR_OPEN':
            return { ...state, isSideBarOpen: action.payload };
        case 'SET_SIDEBAR_STATE':
            return { ...state, sideBarState: action.payload };
        case 'SET_IS_RAG_ENABLED':
            // RAGメニュー表示切替
            // RAGがonになるとき、RAGカテゴリーの選択状況をlocalstorageから取得
            let select_rag_ids = new Set<number>()
            let isRAGSelected = false
            const nextState = action.payload.isEnabled

            let isSideBarOpen = state.isSideBarOpen
            let sideBarState = state.sideBarState

            if(!state.isRAGEnabled && nextState) {
                const rag_ids_data = getCacheSelectedRAGIds()
                if(rag_ids_data){
                    select_rag_ids = new Set<number>(rag_ids_data)
                    isRAGSelected = rag_ids_data.length > 0
                }
                if (action.payload.openRAGMenuIfToggleToOpen) {
                    isSideBarOpen = true
                    sideBarState = "RAG"
                }
            }
            
            return { ...state, currentChat: null, promptTemplateOverride: null, isRAGEnabled: nextState, selectedRAGIds: select_rag_ids, isSideBarOpen, sideBarState };
        case 'SET_RAG_CHAT':
            // RAG選択　(payloadにid)
            // RAGカテゴリーの選択状況をlocalstorageに保存
            setCacheSelectedRAGIds(Array.from(action.payload))
            return { ...state, currentChat: null, promptTemplateOverride: null, selectedRAGIds: new Set<number>(Array.from(action.payload)) };
        case 'SET_DOCUMENT_SEARCH_TOOL_ARG':
            return { ...state, documentSearchToolArg: Object(action.payload)};
        case 'UPDATE_CURRENT_CHAT':
            return { ...state, currentChat: action.payload };
        case 'UPDATE_CHAT_HISTORY_LOADING_STATE':
            return { ...state, chatHistoryLoadingState: action.payload };
        case 'UPDATE_CHAT_HISTORY':
            {
                const chatHistoryState = state.chatHistory ?? [];
                let conversationIndex = chatHistoryState.findIndex(conv => conv.id === action.payload.id);
                if (conversationIndex !== -1) {
                    let updatedChatHistory = [...chatHistoryState];
                    updatedChatHistory[conversationIndex] = action.payload
                    return {...state, chatHistory: updatedChatHistory}
                } else {
                    return { ...state, chatHistory: [...chatHistoryState, action.payload] };
                }
            }
        case 'UPDATE_CHAT_TITLE':
            if(!state.chatHistory){
                return { ...state, chatHistory: [] };
            }
            let updatedChats = state.chatHistory.map(chat => {
                if (chat.id === action.payload.id) {
                    if(state.currentChat?.id === action.payload.id){
                        state.currentChat.title = action.payload.title;
                    }
                    //TODO: make api call to save new title to DB
                    return { ...chat, title: action.payload.title };
                }
                return chat;
            });
            return { ...state, chatHistory: updatedChats };
        case 'CHANGE_CHAT_FAVORITE':
            if(!state.chatHistory){
                return { ...state, chatHistory: [] };
            }
            let targetChats_favorite = state.chatHistory.map(chat => {
                if (chat.id === action.payload.id) {
                    if(state.currentChat?.id === action.payload.id){
                        state.currentChat.is_favorite = action.payload.is_favorite;
                    }
                    return { ...chat, is_favorite: action.payload.is_favorite };
                }
                return chat;
            });
            return { ...state, chatHistory: targetChats_favorite };
        case 'DELETE_CHAT_ENTRY':
            if(!state.chatHistory){
                return { ...state, chatHistory: [] };
            }
            let filteredChat = state.chatHistory.filter(chat => chat.id !== action.payload);
            state.currentChat = null;
            //TODO: make api call to delete conversation from DB
            return { ...state, chatHistory: filteredChat };
        case 'DELETE_CHAT_HISTORY':
            //TODO: make api call to delete all conversations from DB
            if(!state.chatHistory){
                return { ...state, currentChat: null };
            }
            let filteredHistory = state.chatHistory.filter(chat => !(chat.rag_ids?.length === action.payload.size && chat.rag_ids?.every((ragId) => action.payload.has(ragId))));
            return { ...state, chatHistory: filteredHistory, currentChat: null };
            // return { ...state, chatHistory: [], filteredChatHistory: [], currentChat: null };
        case 'DELETE_CURRENT_CHAT_MESSAGES':
            //TODO: make api call to delete current conversation messages from DB
            if(!state.currentChat || !state.chatHistory){
                return state;
            }
            const updatedCurrentChat = {
                ...state.currentChat,
                messages: []
            };
            return {
                ...state,
                currentChat: updatedCurrentChat
            };
        case 'FETCH_CHAT_HISTORY':
            return { ...state, chatHistory: action.payload };
        case 'UPDATE_GENERATING_CONVERSATIONS':
            return { ...state, generatingConversations: new Map(action.payload) };
        case 'APPEND_CHAT_HISTORY':
            {
                // idの重複を排除する(既存の並び順を維持しつつ、内容は新しく取得したもので上書き)
                // マージはreducer内で行う。呼び出し側のクロージャが持つchatHistoryは
                // fetchのawait中に他のdispatchで古くなっている可能性があるため
                const merged = new Map<string, Conversation>();
                (state.chatHistory ?? []).forEach(conv => merged.set(conv.id, conv));
                action.payload.forEach(conv => merged.set(conv.id, conv));
                return { ...state, chatHistory: Array.from(merged.values()) };
            }
        case 'FETCH_CHAT_HISTORY_MESSAGES':
            {
                const {convId, messages} = action.payload
                if(!state.chatHistory) {
                    return state;
                }
                const updatedChatHistory = state.chatHistory.map(chat => {
                    if (chat.id === convId) {
                        return { ...chat, messages: messages };
                    }
                    return chat;
                });
                return { ...state, chatHistory: updatedChatHistory };
            }
        case 'SET_COSMOSDB_STATUS':
            return { ...state, isCosmosDBAvailable: action.payload };
        case 'FETCH_RAG_MENU_LIST':
            return { ...state, RAGMenuList: action.payload };
        case 'SET_SELECTED_GPT_MODEL_INDEX':
            return { ...state, selectedGPTModelIndex: action.payload, promptTemplateOverride: null };
        case 'SET_MESSAGE_FEEDBACK':
            const {convId, mesId, feedback} = action.payload
            // 現在のチャットチェック
            let currentChat = state.currentChat
            const mes1 = currentChat?.messages.find((v) => v.id == mesId)
            if (mes1 && currentChat) {
                mes1.user_feedback = feedback
                currentChat = {
                    ...currentChat
                };
            }
            // チャット履歴チェック (一応)
            let chatHistory = state.chatHistory
            const mes2 = chatHistory?.find((v) => v.id == convId)?.messages.find((v) => v.id == mesId)
            if (mes2 && chatHistory) {
                mes2.user_feedback = feedback
                chatHistory = [...chatHistory]
            }
            return { ...state, currentChat: currentChat, chatHistory: chatHistory };
        case 'SET_PROMPT_TEMPLATE_OVERRIDE':
            return { ...state, promptTemplateOverride: action.payload }
        case 'SET_TOOLS':
            return { ...state, tools: action.payload }
        case 'SET_AVAILABLE_MODELS':
            return { ...state, availableModels: new Map(action.payload) }
        case 'SET_LOGIN_USER_INFO':
            return { ...state, loginUserInfo: action.payload}
        default:
            return state;
      }
};